<template>
  <!-- :label="$vuetify.breakpoint.smAndDown ? $t('products.orderBy') : ''" -->
  <v-row no-gutters align="center" justify="end" class="product-sort-filters">
    <v-select
      :items="sortOptions"
      :value="sortFilter"
      @change="handleSortFilter"
      :label="$t('products.orderBy')"
      outlined
      hide-details
    >
    </v-select>
  </v-row>
</template>
<style>
.v-select.v-input--is-focused .v-input__control {
  outline: 3px solid var(--v-primary-base) !important; /* Use your brand color */
  outline-offset: 2px;
}
</style>
<script>
export default {
  name: "ProductSortFilter",
  data() {
    return {
      sortOptions: [
        { value: "rank", text: "Rilevanza", icon: "ion-arrow-up-c" },
        {
          value: "alf_asc",
          text: "Alfabetico crescente",
          icon: "icon-arrow-up"
        },
        {
          value: "alf_des",
          text: "Alfabetico decrescente",
          icon: "icon-arrow-down"
        },
        {
          value: "pri_asc",
          text: "Prezzo crescente",
          icon: "icon-arrow-down"
        },
        {
          value: "pri_des",
          text: "Prezzo decrescente",
          icon: "ion-arrow-down-c"
        }
      ]
    };
  },
  props: { sortFilter: { type: String } },
  methods: {
    handleSortFilter(sort) {
      this.$emit("handleSortFilter", sort);
    }
  }
};
</script>

<style lang="scss">
.product-sort-filters {
  .v-input__slot {
    min-height: 50px !important;
  }
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    .v-input__slot {
      max-width: 200px !important;
    }
  }
  .v-text-field--outlined fieldset {
    color: #d5d5d5 !important;
    border-radius: 8px;
  }
}
</style>
